import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/_admin/tracker-setup')({
  staticData: {
    title: 'pages.trackerSetup.title',
    description: 'pages.trackerSetup.description',
  },
  component: TrackerSetupPage,
});

function TrackerSetupPage() {
  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Tracker Setup</h1>
        <p className="mt-2 text-gray-600">
          Admin: Configure tracking devices and systems
        </p>
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Tracker Configuration
        </h2>
        <p className="text-gray-600">
          This page will allow administrators to configure and manage tracking
          devices and systems.
        </p>
      </div>
    </div>
  );
}
